import { Form, FormGroup, InputGroup, Input } from "reactstrap";

import React from "react";

const SearchBox = ({ setSearch, searchDelay }) => {
  let searchTimeout;
  const handleSearch = (e) => {
    // if a comma is entered, we want to search for multiple terms

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      const searchTerms = e.target.value.split(",");
      setSearch(searchTerms);
    }, searchDelay);
  };

  return (
    <Form>
      <FormGroup>
        <InputGroup>
          <Input
            placeholder={"Search UTM Computer Science Lecturers"}
            type="text"
            id="text"
            autoComplete="off"
            onChange={handleSearch}
          />
        </InputGroup>
      </FormGroup>
    </Form>
  );
};

export default React.memo(SearchBox);
